import React, {useRef} from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert';

import Toast from '@base/Toast'
import VisualizadorDeArquivo from "@base/VisualizadorDeArquivo";
import { VisualizarCartao, DescartarCartao, ReetiquetarCartao } from "@base/CartaoUtils/CartaoUtils";

export const PaperCartaoDuplicado = ({ processo, blob, cartao, cartoes, onCartoesUpdate, listagemStatus }) => {
  const toastRef = useRef(null);

  const isDescartado = cartao.status === "DESCARTADO";
  const isCodigosIguais = cartao.codigo === cartao.codigoOriginal;

  const getStatus = (status) => listagemStatus.find(st => st.value === status).label;

  return (
    <Paper 
      elevation={3} 
      color="secondary"
      style={{
        marginTop: '10px',
        padding: '5px',
        color: isDescartado ? "#bbb" : null,
        border: isDescartado || !isCodigosIguais ? "ridge" : "none",
        borderColor: isDescartado ? "#ff3d00" : !isCodigosIguais ? "#52b202" : ""
      }}
    >
      <Toast ref={toastRef}/>
      
      <Grid container>
        <Grid item lg={10}>
          <Table size='small'>
            <TableBody>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }} align={"right"} >Código</TableCell>
                <TableCell style={{ color: isDescartado ? "#bbb" : null }} align={"left"} >{cartao.codigo}</TableCell>
                <TableCell style={{ fontWeight: 'bold' }} align={"right"} >Código Original</TableCell>
                <TableCell style={{ color: isDescartado ? "#bbb" : null }} align={"left"} >{cartao.codigoOriginal}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }} align={"right"} >Objeto Postal</TableCell>
                <TableCell style={{ color: isDescartado ? "#bbb" : null }} align={"left"} >{cartao.numeroObjetoPostal}</TableCell>
                <TableCell style={{ fontWeight: 'bold' }} align={"right"} >INEP</TableCell>
                <TableCell style={{ color: isDescartado ? "#bbb" : null }} align={"left"} >{cartao.codigoInep}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }} align={"right"} >Origem</TableCell>
                <TableCell style={{ color: isDescartado ? "#bbb" : null }} align={"left"} >{cartao.origem.descricao}</TableCell>
                <TableCell style={{ fontWeight: 'bold' }} align={"right"} >Status</TableCell>
                <TableCell style={{ color: isDescartado ? "#bbb" : null }} align={"left"} >{getStatus(cartao.status)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        <Grid item lg={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
          <VisualizarCartao 
            cartao={cartao}
            processo={processo}
            mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de cartão duplicado será automaticamente atualizada para 'Resolvida'"}
            aoDescartar={() => onCartoesUpdate()}
            motivosDescarteDisponiveis={() => [{ value: 'DUPLICADO', label: 'Duplicado'}]}
            cartoes={cartoes}
            aoFechar={() => onCartoesUpdate()} 
          />

          <ReetiquetarCartao 
            cartao={cartao}
            processo={processo}
            aoTransferir={() => onCartoesUpdate()}
            aoFechar={() => onCartoesUpdate()}
          />

          <DescartarCartao 
            cartao={cartao}
            processo={processo}
            mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de cartão duplicado será automaticamente atualizada para 'Resolvida'"}
            aoDescartar={() => onCartoesUpdate()}
            motivosDescarteDisponiveis={() => [{ value: 'DUPLICADO', label: 'Duplicado'}]}
            cartoes={cartoes}
            aoFechar={() => onCartoesUpdate()}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item lg={12}>
          {cartao.nomeArquivo == null ?
            <Alert severity="warning">Este cartão ainda não possui digitalização</Alert>
          :
            <VisualizadorDeArquivo blob={blob} />
          }
        </Grid>
      </Grid>
    </Paper>
  );
}
export default PaperCartaoDuplicado;
